import { MediaHelper } from "../../../../helpers";
import Module from "../../../../models/module/Module";
import StandardTextFormEditorComponent from "../../../basics/form/StandardTextFormEditorComponent";
import MediaImageUploadComponent from "../../../media/image/MediaImageUploadComponent";
import AdditionalFieldFormError from "../errors/AdditionalFieldFormError";

class AdditionalFieldOptionTextFormComponent {
    static fields(isEdit = false, model = null, settings = {}) {
        let fields = [{
            type: "col",
            md: 12,
            fields: [
                {
                    title: "CMS.Modules.AdditionalField.Options.Content.Form.label",
                    type: "text",
                    name: 'label',
                    customFeedback: AdditionalFieldFormError,
                    formErrorName: 'label',
                }
            ]
        }, {
            type: "col",
            md: 12,
            fields: [],
            custom: StandardTextFormEditorComponent,
            customProps: { valueField: 'content' }
        },
        {
            type: "col",
            md: 12,
            fields: [],
            custom: MediaImageUploadComponent,
            customProps: { label: 'CMS.Product.Content.Form.image', type: 'additional_field_option_image', settings: settings, field: 'image', formErrorName: 'image' }
        }];

        return [{
            type: "row",
            children: fields
        }];
    }

    static async fields_image_before_submit(element) {
        return new Promise(async (resolve, reject) => {
            let module = Module.get();
            let item = element.state.model;

            let type = module ? module.type : null;

            if (item.image !== null && item.image !== undefined && (typeof item.image !== 'string')) {
                item.image = await MediaHelper.uploadImage(item, 'image', 'additional_field_option_image', type, element.props.id, null, item.title);
            }

            element.setState({ model: item }, () => resolve(true))
        })
    }
}

export default AdditionalFieldOptionTextFormComponent;